<template>
  <v-main>
    <Navbar :user="getUser" :loading="loading"></Navbar>
    <router-view />
  </v-main>
</template>

<script lang="ts">
import { useToolGetters, useUserGetters } from '@/store';

// Async: this layout is registered globally in main.ts, so a static import put Navbar + SetupWizard
// + airtable + fuse (~49 KB gzip) into the entry bundle even on no-nav routes like /guide.
export default {
  components: {
    Navbar: () => import('@/components/Navbar.vue')
  },
  setup() {
    const { getLinearLoading: loading } = useToolGetters(['getLinearLoading']);
    return {
      getUser: useUserGetters(['getUser']).getUser,
      loading
    };
  }
};
</script>
